import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { AdminPanelService } from '../../services/admin-panel.service';
import { APIUrl } from '../../app-service-routing';

export interface UserData {
  firstName: string;
  emailID: string;
  company: string;
  gender: string;
  dob: string
}


@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})


export class UsersComponent implements OnInit {
  userlist: any;
  alphabet: any;
  displayedColumns: string[] = ['firstName', 'emailID', 'company', 'gender', 'dob'];
  dataSource: MatTableDataSource<UserData>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(private router: Router, private service: AdminPanelService, private activeRoute: ActivatedRoute, ) {
  }


  ngOnInit() {
    this.alphabet = 'abcdefghijklmnopqrstuvwxyz'.toUpperCase().split('');
    let leter = ''
    this.userlists(leter);

  }

  userlists(leter) {
    this.service.getReseultSetList(APIUrl.userlistUrl + leter).subscribe(response => {
      this.userlist = response;
      this.dataSource = new MatTableDataSource(this.userlist);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      // console.log(this.consumerlist);
      // this.infoTableDataSource = this.consumerlist;
    }, error => {
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  alphasearch(letter) {
    this.userlists(letter);
  }

  getColor(color) {
    switch (color) {
      case 'Deposit':
        return 'green';
      case 'Redeem':
        return 'red';
      case 'HK':
        return 'red';
    }
  }
}
